import { IconButton, Typography, InputBase } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";

import {
  globalSearchText,
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  addFreezeAccount,
  getAccountDetailsToAdd,
  updateFreezeAccountDetails,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import SearchIcon from "@mui/icons-material/Search";
import ToolbarFilterButton from "../../components/ToolbarFilterButton";
import DatePickerDialog from "../../components/DatePickerDialog";
import CustomButtonSmall from "../../components/CustomButtonSmall";
import AddDealerFreezeAccountDialog from "./AddDealerFreezeAccountDialog";
import AddFreezeAccountDialog from "./AddFreezeAccountDialog";
import { freezeFilterItemsDetails } from "../../data/freezeFilterItems";
import { CustomToolbarWithoutExport } from "../../components/DataGridCustomToolBarWithoutExport";

export function FreezeUnfreezeDealer() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  // filterCriteria is fetched from API and has the structure of [{ "displayName": "NAME", "paramName": "accountName" }]
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([
    { keyValue: "", displayName: "", paramName: "" },
  ]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");

  const [gridHeight, setGridHeight] = useState(108); // Default height

  const [currentPage, setCurrentPage] = useState(0);

  //const [open, setOpen] = useState(false);
  const [accountDetailsToAdd, setAccountDetailsToAdd] = useState([]);
  const [searchInitiated, setSearchInitiated] = useState(false);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);

  const [openSaveAndRemoveDialog, setOpenSaveAndRemoveDialog] = useState(false);
  const [openAddFreezeAccountDialog, setOpenAddFreezeAccountDialog] =
    useState(false);

  // const [selectedDealerName, setSelectedDealerName] = useState("");
  // const [selectedDealerCode, setSelectedDealerCode] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(25);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [searchQueryPlaceholder, setSearchQueryPlaceholder] =
    useState("Search Name");
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  const [searchDealerQuery, setDealerSearchQuery] = useState(""); //useAtom(globalSearchText);

  const handleAddDealerStatusCloseDialog = () => {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);

    //DateCalendarReferenceDate()
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 65; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= paginationModel.pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }
    const totalHeight = headerHeight + (rowCount + 1) * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  useEffect(() => {
    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    // setSearchQuery("");
  }, [filter]);

  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find(
      (item) => item.displayName === filter
    );
    setFilter(selectedFilter);
  };

  useEffect(() => {
    setFilterCriteria(freezeFilterItemsDetails.result);
    setFilterDisplayOptions(
      freezeFilterItemsDetails.result.map((item) => item.displayName)
    );
    setDefaultFilter(freezeFilterItemsDetails.result[0].displayName);
    setFilter(freezeFilterItemsDetails.result[0]);

    setDefaultFilter("companyName");

    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, totalNoOfRows]);

  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    // Avoid using state directly for API call as the state update function is async.
    // Means it will not update the state immediately and it will be using the old state value.
    searchFreezeAccountDetails(newPage, paginationModel.pageSize);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    searchFreezeAccountDetails(newPage, paginationModel.pageSize);
  };
  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    searchFreezeAccountDetails(0, newPageSize);
  };

  // get result from search query button update
  function addDealerSearchButtonClicked() {
    if (searchDealerQuery === "") {
      alert("Please enter some value!");
    } else if (filter === "") {
      searchFreezeAccountDetails(
        paginationModel.page,
        paginationModel.pageSize
      );

      //getFreezeAccountDetailsToAdd(searchDealerQuery, "Company Name");
    } else {
      searchFreezeAccountDetails(
        paginationModel.page,
        paginationModel.pageSize
      );

      //getFreezeAccountDetailsToAdd(searchDealerQuery, filter);
    }
  }
  // Create Request Object for searchFreezeAccountDetails API
  function createRequestObject(
    pageNumber,
    pageSize,
    selectedFilter,
    filterValue
  ) {
    // Initialize all fields to null
    let requestObject = {
      companyCode: null,
      frozeBy: null,
      companyName: null,
      reason: null,
      vendorCode: null,
    };

    // Set the appropriate field based on filterCriteria
    if (
      selectedFilter != null &&
      selectedFilter != undefined &&
      selectedFilter.paramName != ""
    ) {
      requestObject[selectedFilter.paramName] = filterValue;
    }

    return requestObject;
  }
  // search accounts after user click search button
  function searchFreezeAccountDetails(pageNumber, pageSize) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNumber,
          pageSize,
          filter,
          searchDealerQuery
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_FREEZE_ACCOUNT_DEALER_LIST
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };
          // response.data.result.accountList
          getAccountDetailsToAdd(requestData)
            .then((response) => {
              const contentData = response.data.result.accountList.map(
                (row) => ({
                  ...row,
                  id: generateRandomId(),
                })
              );
              setAccountDetailsToAdd(contentData);
              setRowsPerPage(response.data.result.accountList.length);
              // setTotalNoOfRows(response.data.result.accountList.totalElements);
              // setTotalNoOfPages(response.data.result.accountList.totalPages);

              setTotalNoOfRows(response.data.result.accountList.length);
              setTotalNoOfPages(response.data.result.accountList.length);

              setSearchInitiated(true);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });

          setLoading(false);
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  // // data === null || data === undefined
  async function requestUpdateFreezeAccountDetailsData(
    params,
    updatedValue,
    selectedFile
  ) {
    let base64Content = "";
    let fileNameWithoutExtension = "";
    let requestObject;
    let requestData;

    if (selectedFile) {
       fileNameWithoutExtension = selectedFile.name
        .split(".")
        .slice(0, -1)
        .join(".");

      const fileBase64Encoding = await getBase64(selectedFile);
      // Extract only the Base64 data
      base64Content = fileBase64Encoding.split(",")[1];

    }


    if (
      params.status === null ||
      params.status === undefined ||
      params.status === ""
    ) {
      try {
        if (isNetworkConnectionAvailable) {
         
          

          if (selectedFile) {
            // const fileNameWithoutExtension = selectedFile.name
            //   .split(".")
            //   .slice(0, -1)
            //   .join(".");

            // const fileBase64Encoding = await getBase64(selectedFile);
            // // Extract only the Base64 data
            // base64Content = fileBase64Encoding.split(",")[1];
            //const fileByteArray = await getByteArray(selectedFile);
            requestObject = {
              fileName: fileNameWithoutExtension,
              fileType: selectedFile.type,
              accountName: updatedValue.company,
              accountCode: updatedValue.code,
              vendorCode: updatedValue.vendorCode,
              freezeReason: updatedValue.frozenReason,
              pic: updatedValue.pic,
              bankAccountNumber: updatedValue.accountNo,
              bankName: updatedValue.bank,
            };
          } else {
            requestObject = {
              accountName: updatedValue.company,
              accountCode: updatedValue.code,
              vendorCode: updatedValue.vendorCode,
              freezeReason: updatedValue.frozenReason,
              pic: updatedValue.pic,
              bankAccountNumber: updatedValue.accountNo,
              bankName: updatedValue.bank,
            };
          }

          setProgressbarText(PROCESSING_PLEASE_WAIT);
          setLoading(true);

          // const requestObject = {
          //   accountName: updatedValue.company,
          //   accountCode: updatedValue.code,
          //   vendorCode: updatedValue.vendorCode,
          //   freezeReason: updatedValue.frozenReason,
          //   pic: updatedValue.pic,
          //   // actionStatus: "",
          //   bankAccountNumber: updatedValue.accountNo,
          //   bankName: updatedValue.bank,
          // };

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.ADD_FREEZED_ACCOUNT
          ).then((encryptedContentData) => {
            
            if (base64Content !== null && base64Content !== "") {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
                fileContent: base64Content,
              };
            } else {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
              };
            }

            // const requestData = {
            //   requestId: generateRequestId(),
            //   loginId: getFromLocalStorage(LOGIN_ID),
            //   sessionId: getFromLocalStorage(SESSION_ID),
            //   loginUserName: getFromLocalStorage(USER_NAME),
            //   contentData: encryptedContentData,
            // };

            addFreezeAccount(requestData)
              .then((response) => {
                addDealerSearchButtonClicked();
                setLoading(false);
                showErrorAlert(
                  "UPDATED",
                  "Freeze account details updated successfully."
                );
              })
              .catch((error) => {
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.data != null
                      ? error.data.displayErrorMessage
                      : SOME_ERROR_OCCURRED;

                  if (message)
                    showErrorAlert(
                      ERROR,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    } else if (params.status === "Unfrozen") {
      try {
        if (isNetworkConnectionAvailable) {
          setProgressbarText(LOADING_PLEASE_WAIT);
          setLoading(true);
         

          if (selectedFile) {
            
            requestObject = {
              fileName: fileNameWithoutExtension,
              fileType: selectedFile.type,
              accountCode: updatedValue.code,
            actionStatus: "1",
            freezeReason: updatedValue.frozenReason,
            };
          } else {
            requestObject = {
              accountCode: updatedValue.code,
            actionStatus: "1",
            freezeReason: updatedValue.frozenReason,
            };
          }

          // const requestObject = {
          //   accountCode: updatedValue.code,
          //   actionStatus: "1",
          //   freezeReason: updatedValue.frozenReason,
          // };

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.GET_EARMARKS_DETAILS
          ).then((encryptedContentData) => {

            if (base64Content !== null && base64Content !== "") {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
                fileContent: base64Content,
              };
            } else {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
              };
            }
            
            // const requestData = {
            //   requestId: generateRequestId(),
            //   loginId: getFromLocalStorage(LOGIN_ID),
            //   sessionId: getFromLocalStorage(SESSION_ID),
            //   loginUserName: getFromLocalStorage(USER_NAME),
            //   contentData: encryptedContentData,
            // };

            updateFreezeAccountDetails(requestData)
              .then((response) => {
                addDealerSearchButtonClicked();
                setLoading(false);
                showErrorAlert("FREEZED", "Account Freezed successfully.");
              })
              .catch((error) => {
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.data != null
                      ? error.data.displayErrorMessage
                      : SOME_ERROR_OCCURRED;

                  if (message)
                    showErrorAlert(
                      ERROR,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    } else if (params.status !== "Unfrozen") {
      try {
       
        if (isNetworkConnectionAvailable) {
          setProgressbarText(LOADING_PLEASE_WAIT);
          setLoading(true);

         
          if (selectedFile) {
            requestObject = {
              fileName: fileNameWithoutExtension,
              fileType: selectedFile.type,
              accountCode: params.accountCode,
              actionStatus: "1",
              unFreezeReason: updatedValue.frozenReason,
            };
          } else {
            requestObject = {
              accountCode: params.accountCode,
              actionStatus: "1",
              unFreezeReason: updatedValue.frozenReason,
            };
          }

          // const requestObject = {
          //   accountCode: params.accountCode,
          //   actionStatus: "1",
          //   unFreezeReason: updatedValue.frozenReason,
          //};

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.GET_EARMARKS_DETAILS
          ).then((encryptedContentData) => {
            if (base64Content !== null && base64Content !== "") {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
                fileContent: base64Content,
              };
            } else {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                loginUserName: getFromLocalStorage(USER_NAME),
                contentData: encryptedContentData,
              };
            }
            // const requestData = {
            //   requestId: generateRequestId(),
            //   loginId: getFromLocalStorage(LOGIN_ID),
            //   sessionId: getFromLocalStorage(SESSION_ID),
            //   loginUserName: getFromLocalStorage(USER_NAME),
            //   contentData: encryptedContentData,
            // };

            updateFreezeAccountDetails(requestData)
              .then((response) => {
                setLoading(false);
                showErrorAlert(
                  "UN-FREEZED",
                  "Account Un-Freezed successfully."
                );
                addDealerSearchButtonClicked();
              })
              .catch((error) => {
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.data != null
                      ? error.data.displayErrorMessage
                      : SOME_ERROR_OCCURRED;

                  if (message)
                    showErrorAlert(
                      ERROR,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }

  function requestUnFreezeAccountDetailsData(params, updatedValue) {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
  }

  const freezeButton = (rowData) => {
    return (
      <CustomButtonSmall
        btnBG={colors.primary[100]}
        btnColor={colors.grey[900]}
        btnTxt={"FREEZE"}
        btnBorder={"1px solid" + colors.primary[100]}
        onClick={() => handleAddFreezeAccountClick(rowData)}
      ></CustomButtonSmall>
    );
  };

  const unfreezeButton = (rowData) => {
    return (
      <CustomButtonSmall
        btnBG={colors.white[300]}
        btnColor={colors.primary[300]}
        btnTxt={"UNFREEZE"}
        btnBorder={"1px solid" + colors.grey[100]}
        onClick={() => handleUnFreezeAccountClick(rowData)}
      ></CustomButtonSmall>
    );
  };

  const handleAddFreezeAccountClick = (rowData) => {
    if(rowData.isEditAble==="true"){
      setSelectedItem(rowData);
      setOpenSaveAndRemoveDialog(true);
    }else{
      showErrorAlert(ALERT,"Status change is not allowed!")
    }
   
  };

  const handleUnFreezeAccountClick = (rowData) => {
    if(rowData.isEditAble==="true"){
    setSelectedItem(rowData);
    setOpenAddFreezeAccountDialog(true);
  }else{
    showErrorAlert(ALERT,"Status change is not allowed!")
  }
  };

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />

        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        <AddDealerFreezeAccountDialog
          open={openSaveAndRemoveDialog}
          onClose={handleAddDealerStatusCloseDialog}
          onDialogButtonClick={requestUpdateFreezeAccountDetailsData}
          onDialogRemoveButtonClick={requestUnFreezeAccountDetailsData}
          data={selectedItem}
        />

        <AddFreezeAccountDialog
          open={openAddFreezeAccountDialog}
          onClose={handleAddDealerStatusCloseDialog}
          onDialogButtonClick={requestUpdateFreezeAccountDetailsData}
          onDialogRemoveButtonClick={requestUnFreezeAccountDetailsData}
          data={selectedItem}
          screenType={1}
        />

        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            mb={2}
            ml={2}
            mt={1}
          >
            <Grid item mr={2}>
              <IconButton href={CONSTANT.FREEZE_ACCOUNT_ROUTE} width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>

            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                {"Add Dealer"}
              </Typography>
            </Grid>

            <Box position="absolute" right={30} top={100}>
              <Grid container direction={"row"} alignItems={"center"}>
                {/* SEARCH BAR */}
                <Box
                  backgroundColor={colors.grey[900]}
                  borderRadius="20px"
                  ml={5}
                  mr={2}
                >
                  <InputBase
                    sx={{ ml: 2, flex: 1 }}
                    placeholder="Search Dealer"
                    value={searchDealerQuery}
                    onChange={(e) => setDealerSearchQuery(e.target.value)}
                  />

                  <IconButton type="button" sx={{ p: 1 }}>
                    <SearchIcon onClick={addDealerSearchButtonClicked} />
                  </IconButton>
                </Box>

                <ToolbarFilterButton
                  options={filterDisplayOptions}
                  defaultOption={defaultFilter}
                  onChange={handleFilterChange}
                  name={"FILTERS"}
                />

                {/* <ToolbarFilterButton
                  name={"FILTER"}
                  options={[
                    "Company Name",
                    "Dealer Code",
                    "Vendor Code",
                    "Status",
                    "Reason",
                  ]}
                  defaultOption={defaultFilter}
                  onChange={handleFilterChange}
                /> */}

                {/* <button onClick={handleOpenDialog}>Open Date Picker</button> */}
              </Grid>
            </Box>
          </Grid>

          <DatePickerDialog open={isDialogOpen} onClose={handleCloseDialog} />
          {/* Header */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {!searchInitiated ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="450px"
                width="100%"
              >
                <Typography variant="h6" align="center">
                  Search results will be displayed here.
                </Typography>
              </Box>
            ) : accountDetailsToAdd.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  // rows={filteredRows.slice(
                  //   currentPage * pageSize,
                  //   (currentPage + 1) * pageSize
                  // )}
                  // columns={FreezeAccountAddDealerColumnHeader(freezeButton,unfreezeButton)}
                  // components={{ Toolbar: GridToolbar }}
                  // pageSize={pageSize}
                  // rowCount={filteredRows.length}
                  // pagination
                  // onPageChange={handlePageChange}

                  rows={accountDetailsToAdd}
                  columns={FreezeAccountAddDealerColumnHeader(
                    freezeButton,
                    unfreezeButton
                  )}
                  components={{ Toolbar: CustomToolbarWithoutExport }}
                  checkboxSelection={false}
                  selecion
                  pageSize={pageSize}
                  pageSizeOptions={[25, 50, 100]}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  // onRowClick={handleRowClick}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {accountDetailsToAdd.length > 0 ? (
            <Box>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}

export const FreezeAccountAddDealerColumnHeader = (
  freezeButton,
  unfreezeButton
) => [
  {
    field: "id",
    filterable: false,
    headerName: "ID",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },
  {
    field: "isEditAble",
    filterable: false,
    headerName: "IsEditable",
    flex: 0.5,
    hide: true,
    headerAlign: "left",
  },

  
  {
    field: "accountName",
    headerName: "NAME",
    flex: 1.5,
    cellClassName: "bold-column--cell",
    headerAlign: "left",
  },

  {
    field: "accountCode",
    headerName: "CODE",
    flex: 1,
    headerAlign: "left",
  },

  {
    field: "vendorCode",
    headerName: "VENDOR",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "bankName",
    headerName: "BANK NAME",
    flex: 1,
    headerAlign: "left",
  },
  {
    field: "bankAccountNumber",
    headerName: "BANK A/C NUMBER",
    flex: 1,
    headerAlign: "left",
    cellClassName: "bold-column--cell",
  },
  {
    field: "status",
    headerName: "ACTIONS",
    flex: 1,
    headerAlign: "left",

    filterable: false,
    renderCell: (params) =>
      params.value === "Unfrozen" || params.value === null
        ? freezeButton(params.row)
        : unfreezeButton(params.row),
  },
];

export const freezeAccountButtonClick = (id) => {
  alert("button click");
  // Handle button click action here
};
